<script>
export default {
  metaInfo () {
    return {
    }
  }
}
</script>
